import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@common/musicHubCommon';
import { ROUTES } from '../../../routes';
import { reportPageView } from '../../../services/reportLog';
import './index.scss';

const SONG_ICON = 'https://akoss.bangcdn.net/fe/song.svg';
const ALBUM_ICON = 'https://akoss.bangcdn.net/fe/EP.svg';

type UploadType = 'song' | 'album' | null;

const ReleaseType: React.FC = () => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<UploadType>(null);

  useEffect(() => {
    reportPageView('content_0009', { withArtistId: true });
  }, []);

  const handleNext = () => {
    if (!selectedType) return;
    
    // 保存选择到 sessionStorage
    sessionStorage.setItem('releaseType', selectedType);
    
    if (selectedType === 'song') {
      // 单曲流程 -> 上传音频页面
      navigate(ROUTES.releaseUpload);
    } else {
      // 专辑流程 -> 创建专辑页面
      navigate(ROUTES.albumCreate);
    }
  };

  const handleBack = () => {
    navigate(ROUTES.dashboard);
  };

  return (
    <div className="release-type">
      {/* 页面标题 */}
      <div className="release-type__header">
        <button className="back-btn" onClick={handleBack}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
          </svg>
          <span>Release Song</span>
        </button>
      </div>

      {/* 主内容 */}
      <div className="release-type__content">
        <div className="release-type__card">
          {/* 标题区域 */}
          <div className="release-type__title">
            <h1>Select your upload type</h1>
            <p>Unlimited storage for free</p>
          </div>

          {/* 类型选择卡片 */}
          <div className="release-type__options">
            {/* Song 卡片 */}
            <div 
              className={`type-card ${selectedType === 'song' ? 'type-card--selected' : ''}`}
              onClick={() => setSelectedType('song')}
            >
              <img src={SONG_ICON} alt="" className="type-card__icon type-card__icon--music" />
              <span className="type-card__label">Song</span>
            </div>

            {/* Album/EP 卡片 - 本期暂不支持 */}
            <div 
              className={`type-card type-card--disabled`}
              onClick={() => {/* 本期禁用 album 功能 */}}
            >
              <img src={ALBUM_ICON} alt="" className="type-card__icon type-card__icon--album" />
              <span className="type-card__label">Album / EP</span>
              <span className="type-card__coming-soon">Coming Soon</span>
            </div>
          </div>

          {/* Next 按钮 */}
          <Button
            type="primary"
            disabled={!selectedType}
            onClick={handleNext}
            className={`release-type__submit ${!selectedType ? 'release-type__submit--disabled' : ''}`}
          >
            Next
          </Button>

          {/* 底部说明 */}
          <p className="release-type__notice">
            Phoenix uploads are for artists and content creators only. DO NOT upload your personal music collection or unauthorized content.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReleaseType;
